import React from 'react'
import MessageUI from './MessageUI'
import './Tab.css'

const TabUI = ({messageList, labelKey, label, onClick, active}) =>
  <div className={`w_tab g_muted ${active ? 'active' : ''}`} onClick={onClick}>
    {
      label &&
      <span>{label}</span>
    }
    {
      !label &&
      <MessageUI messageList={messageList} messageKey={labelKey} />
    }
  </div>

export default TabUI
